(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1465],{

/***/ 36158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Od": function() { return /* binding */ Skeleton; }
});

// UNUSED EXPORTS: SkeletonCircle, SkeletonText

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react-use-previous/dist/index.esm.js
// src/index.ts

function usePrevious(value) {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}


// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 4 modules
var index_esm = __webpack_require__(15818);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.esm.js
var dist_index_esm = __webpack_require__(54520);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(51469);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js
// ../../../react-shim.js


// src/skeleton.tsx


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// src/skeleton.tsx


// src/use-is-first-render.ts

function useIsFirstRender() {
  const isFirstRender = (0,react.useRef)(true);
  (0,react.useEffect)(() => {
    isFirstRender.current = false;
  }, []);
  return isFirstRender.current;
}

// src/skeleton.tsx
var StyledSkeleton = (0,index_esm/* chakra */.m$)("div", {
  baseStyle: {
    boxShadow: "none",
    backgroundClip: "padding-box",
    cursor: "default",
    color: "transparent",
    pointerEvents: "none",
    userSelect: "none",
    "&::before, &::after, *": {
      visibility: "hidden"
    }
  }
});
var $startColor = (0,dist_index_esm/* cssVar */.gJ)("skeleton-start-color");
var $endColor = (0,dist_index_esm/* cssVar */.gJ)("skeleton-end-color");
var fade = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: { opacity: 0 },
  to: { opacity: 1 }
});
var bgFade = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: {
    borderColor: $startColor.reference,
    background: $startColor.reference
  },
  to: {
    borderColor: $endColor.reference,
    background: $endColor.reference
  }
});
var Skeleton = (0,index_esm/* forwardRef */.Gp)((props, ref) => {
  const styles = (0,index_esm/* useStyleConfig */.mq)("Skeleton", props);
  const isFirstRender = useIsFirstRender();
  const {
    startColor = "",
    endColor = "",
    isLoaded,
    fadeDuration,
    speed,
    className,
    ...rest
  } = (0,dist_index_esm/* omitThemingProps */.Lr)(props);
  const [startColorVar, endColorVar] = (0,index_esm/* useToken */.dQ)("colors", [
    startColor,
    endColor
  ]);
  const wasPreviouslyLoaded = usePrevious(isLoaded);
  const _className = cx("chakra-skeleton", className);
  const cssVarStyles = {
    ...startColorVar && { [$startColor.variable]: startColorVar },
    ...endColorVar && { [$endColor.variable]: endColorVar }
  };
  if (isLoaded) {
    const animation = isFirstRender || wasPreviouslyLoaded ? "none" : `${fade} ${fadeDuration}s`;
    return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
      ref,
      className: _className,
      __css: { animation },
      ...rest
    });
  }
  return /* @__PURE__ */ react.createElement(StyledSkeleton, {
    ref,
    className: _className,
    ...rest,
    __css: {
      ...styles,
      ...cssVarStyles,
      _dark: { ...cssVarStyles },
      animation: `${speed}s linear infinite alternate ${bgFade}`
    }
  });
});
Skeleton.defaultProps = {
  fadeDuration: 0.4,
  speed: 0.8
};
Skeleton.displayName = "Skeleton";

// src/skeleton-text.tsx


function range(count) {
  return Array(count).fill(1).map((_, index) => index + 1);
}
var defaultNoOfLines = 3;
var SkeletonText = (props) => {
  const {
    noOfLines = defaultNoOfLines,
    spacing = "0.5rem",
    skeletonHeight = "0.5rem",
    className,
    startColor,
    endColor,
    isLoaded,
    fadeDuration,
    speed,
    children,
    ...rest
  } = props;
  const noOfLinesValue = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)(typeof noOfLines === "number" ? [noOfLines] : noOfLines) || defaultNoOfLines;
  const numbers = range(noOfLinesValue);
  const getWidth = (index) => {
    if (noOfLinesValue > 1) {
      return index === numbers.length ? "80%" : "100%";
    }
    return "100%";
  };
  const _className = cx("chakra-skeleton__group", className);
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    className: _className,
    ...rest
  }, numbers.map((number, index) => {
    if (isLoaded && index > 0) {
      return null;
    }
    const sizeProps = isLoaded ? null : {
      mb: number === numbers.length ? "0" : spacing,
      width: getWidth(number),
      height: skeletonHeight
    };
    return /* @__PURE__ */ react.createElement(Skeleton, {
      key: numbers.length.toString() + number,
      startColor,
      endColor,
      isLoaded,
      fadeDuration,
      speed,
      ...sizeProps
    }, index === 0 ? children : void 0);
  }));
};
SkeletonText.displayName = "SkeletonText";

// src/skeleton-circle.tsx
var SkeletonCircle = ({
  size = "2rem",
  ...rest
}) => /* @__PURE__ */ react.createElement(Skeleton, {
  borderRadius: "full",
  boxSize: size,
  ...rest
});
SkeletonCircle.displayName = "SkeletonCircle";



/***/ }),

/***/ 63695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35656);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);





function HomeSectionBanner(param) {
    let { bannerItems , columns , spacing , linkTarget  } = param;
    // use i18n
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "home"
    ]);
    var _bannerItem_link, _bannerItem_target, _ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .SimpleGrid */ .MI, {
        columns: columns,
        spacing: spacing,
        children: bannerItems.map((bannerItem, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: (_bannerItem_link = bannerItem.link) !== null && _bannerItem_link !== void 0 ? _bannerItem_link : "",
                    target: linkTarget ? linkTarget : (_bannerItem_target = bannerItem.target) !== null && _bannerItem_target !== void 0 ? _bannerItem_target : "_self",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: (_ref = "".concat("https://storage.lamptan.co.th", "/").concat(bannerItem.media.name)) !== null && _ref !== void 0 ? _ref : "image-icon/empty-image.png",
                        alt: "",
                        width: 300,
                        height: 200,
                        quality: 100
                    })
                })
            }, index))
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (HomeSectionBanner);


/***/ }),

/***/ 58920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47741);
/* harmony import */ var hooks_useProductCategories__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88062);
/* harmony import */ var hooks_useProductMainCategories__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68758);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35656);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30719);









function HomeFeaturedCategoriesSection(param) {
    let { featuredCategories  } = param;
    const [controlledSwiper, setControlledSwiper] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)();
    const { productCategories  } = (0,hooks_useProductCategories__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const { productMainCategories  } = (0,hooks_useProductMainCategories__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    // use i18n
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)([
        "home"
    ]);
    // current category
    const [currentCategories, setCurrentCategories] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        // log productCategories
        console.log("productCategories", productCategories);
        // log featuredCategories
        console.log("featuredCategories", featuredCategories);
        if (productCategories.length > 0 && featuredCategories.length > 0) {
            // log featuredCategories
            console.log("featuredCategories", featuredCategories);
            // get categories by id
            const _currentCategories = productCategories.filter((category)=>{
                var _featuredCategories_find;
                return category.id === ((_featuredCategories_find = featuredCategories.find((item)=>item.category == category.id)) === null || _featuredCategories_find === void 0 ? void 0 : _featuredCategories_find.category);
            });
            // log category
            console.log("_currentCategories", _currentCategories);
            setCurrentCategories(_currentCategories);
        }
    }, [
        productCategories,
        featuredCategories
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
        px: {
            base: 10,
            md: 0
        },
        position: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .Swiper */ .tq, {
                onSwiper: setControlledSwiper,
                breakpoints: {
                    320: {
                        slidesPerView: 3,
                        spaceBetween: 10
                    },
                    768: {
                        slidesPerView: 5,
                        spaceBetween: 15
                    },
                    1024: {
                        slidesPerView: 5,
                        spaceBetween: 15
                    }
                },
                children: featuredCategories.map((category, index)=>{
                    var _productMainCategories_find, _currentCategories_find;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                            href: "/product-categories/".concat((_productMainCategories_find = productMainCategories.find((m)=>{
                                var _currentCategories_find;
                                return m.id === ((_currentCategories_find = currentCategories.find((c)=>c.id === category.category)) === null || _currentCategories_find === void 0 ? void 0 : _currentCategories_find.mainCategoryId);
                            })) === null || _productMainCategories_find === void 0 ? void 0 : _productMainCategories_find.permalink, "/").concat(((_currentCategories_find = currentCategories.find((c)=>c.id === category.category)) === null || _currentCategories_find === void 0 ? void 0 : _currentCategories_find.permalink) || ""),
                            legacyBehavior: true,
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Link */ .rU, {
                                display: "block",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: category.media ? "".concat("https://storage.lamptan.co.th", "/").concat(category.media.name) : "/image-icon/empty-image.png",
                                    alt: "",
                                    width: 225,
                                    height: 225
                                })
                            })
                        })
                    }, index);
                })
            }),
            controlledSwiper ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
                        display: {
                            base: "inline-flex",
                            md: "none"
                        },
                        opacity: 0.7,
                        position: "absolute",
                        left: -1,
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "4xl",
                        colorScheme: "primary",
                        variant: "unstyled",
                        bg: "gray.100",
                        width: "28px",
                        minW: "auto",
                        height: "28px",
                        borderRadius: "full",
                        onClick: ()=>controlledSwiper.slidePrev(),
                        _focus: {
                            boxShadow: "none",
                            bg: "#dcdcdc"
                        },
                        _active: {
                            bg: "#dcdcdc"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                            src: "/image-icon/arrow-prev.png",
                            width: 12,
                            height: 14,
                            alt: "prev"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
                        display: {
                            base: "inline-flex",
                            md: "none"
                        },
                        opacity: 0.7,
                        position: "absolute",
                        right: -1,
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "4xl",
                        colorScheme: "primary",
                        variant: "unstyled",
                        bg: "gray.100",
                        width: "28px",
                        minW: "auto",
                        height: "28px",
                        borderRadius: "full",
                        onClick: ()=>controlledSwiper.slideNext(),
                        _focus: {
                            boxShadow: "none",
                            bg: "#dcdcdc"
                        },
                        _active: {
                            bg: "#dcdcdc"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                            src: "/image-icon/arrow-next.png",
                            width: 12,
                            height: 14,
                            alt: "next"
                        })
                    })
                ]
            }) : null
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (HomeFeaturedCategoriesSection);


/***/ }),

/***/ 48444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48641);
/* harmony import */ var components_products_ProductListSwiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77412);
/* harmony import */ var hooks_useCatchError__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65633);
/* harmony import */ var hooks_useProductCategories__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88062);
/* harmony import */ var hooks_useProductMainCategories__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68758);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8100);










function HomeProductCategorySection(param) {
    let { section , hideVerticalOnMobile =false , productType ="lighting"  } = param;
    var _section_products, _productMainCategories_find, _productMainCategories_find1, _productMainCategories_find2, _productMainCategories_find3;
    // catch error hook
    const catchError = (0,hooks_useCatchError__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    // use product categories
    const { productCategories  } = (0,hooks_useProductCategories__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    // use product main categories
    const { productMainCategories  } = (0,hooks_useProductMainCategories__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    // use media query
    const [isMobile] = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .useMediaQuery */ .ac)("(max-width: 767px)");
    // get product form swr
    const { data: productData  } = (0,swr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(section.products && section.products.length > 0 ? "".concat("https://api.lamptan.co.th", "/v1/public/products?ids=").concat((_section_products = section.products) === null || _section_products === void 0 ? void 0 : _section_products.join(","), "&limit=100") : null);
    // current category
    const [currentCategory, setCurrentCategory] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)();
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        if (productCategories.length > 0 && section) {
            // get categories by id
            const _currentCategory = productCategories.find((category)=>category.id === section.category);
            // log category
            console.log("_currentCategory", _currentCategory);
            setCurrentCategory(_currentCategory);
        }
    }, [
        productCategories,
        section
    ]);
    // log products
    console.log("productData", productData);
    var _productMainCategories_find_permalink, _currentCategory_permalink, _ref, _productMainCategories_find_permalink1, _currentCategory_permalink1, _ref1, _productMainCategories_find_permalink2, _currentCategory_permalink2, _productMainCategories_find_permalink3, _currentCategory_permalink3, _ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: section.layout === "vertical" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: isMobile && hideVerticalOnMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Container */ .W2, {
                maxW: "900px",
                py: {
                    base: 4,
                    lg: 0
                },
                bg: "white",
                mb: {
                    base: 5,
                    lg: 10
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Grid */ .rj, {
                    templateColumns: {
                        base: "minmax(0, 1fr)",
                        md: "minmax(0, 315px) minmax(0, 1fr)",
                        lg: "minmax(0, 323px) minmax(0, 1fr)"
                    },
                    columnGap: {
                        md: "25px",
                        lg: "40px"
                    },
                    children: [
                        section.mediaMobile && section.mediaMobile.name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                            position: "relative",
                            mb: 8,
                            display: {
                                md: "none"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                href: "/product-categories/".concat((_productMainCategories_find_permalink = (_productMainCategories_find = productMainCategories.find((category)=>category.id === section.category)) === null || _productMainCategories_find === void 0 ? void 0 : _productMainCategories_find.permalink) !== null && _productMainCategories_find_permalink !== void 0 ? _productMainCategories_find_permalink : "", "/").concat((_currentCategory_permalink = currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.permalink) !== null && _currentCategory_permalink !== void 0 ? _currentCategory_permalink : "", "?productType=").concat(productType),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: (_ref = "".concat("https://storage.lamptan.co.th", "/").concat(section.mediaMobile.name)) !== null && _ref !== void 0 ? _ref : "/image-icon/empty-image.png",
                                    alt: section.mediaMobile.name,
                                    quality: 90,
                                    width: 450,
                                    height: 385
                                })
                            })
                        }),
                        section.mediaDesktop && section.mediaDesktop.name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                            height: "100%",
                            width: "100%",
                            pb: 1,
                            display: {
                                base: "none",
                                md: "block"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                                height: "100%",
                                width: "100%",
                                position: "relative",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                    href: "/product-categories/".concat((_productMainCategories_find_permalink1 = (_productMainCategories_find1 = productMainCategories.find((category)=>category.id === section.category)) === null || _productMainCategories_find1 === void 0 ? void 0 : _productMainCategories_find1.permalink) !== null && _productMainCategories_find_permalink1 !== void 0 ? _productMainCategories_find_permalink1 : "", "/").concat((_currentCategory_permalink1 = currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.permalink) !== null && _currentCategory_permalink1 !== void 0 ? _currentCategory_permalink1 : "", "?productType=").concat(productType),
                                    passHref: true,
                                    legacyBehavior: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .rU, {
                                        height: "100%",
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            src: (_ref1 = "".concat("https://storage.lamptan.co.th", "/").concat(section.mediaDesktop.name)) !== null && _ref1 !== void 0 ? _ref1 : "/image-icon/empty-image.png",
                                            alt: section.mediaDesktop.name,
                                            quality: 90,
                                            width: 450,
                                            height: 385
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                            flex: 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_products_ProductListSwiper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                products: productData && productData.docs.length > 0 ? productData.docs : [],
                                navigation: false,
                                breakpoints: {
                                    300: {
                                        slidesPerView: 2.5,
                                        spaceBetween: 10
                                    },
                                    768: {
                                        slidesPerView: 2.5,
                                        spaceBetween: 20
                                    },
                                    992: {
                                        slidesPerView: 3,
                                        spaceBetween: 30
                                    }
                                }
                            })
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Container */ .W2, {
            maxW: "900px",
            py: {
                base: 4,
                lg: 0
            },
            bg: "white",
            mb: {
                base: 5,
                lg: 10
            },
            children: [
                section.mediaDesktop && section.mediaDesktop.name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                    position: "relative",
                    mb: 10,
                    display: {
                        base: "none",
                        md: "block"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        href: "/product-categories/".concat((_productMainCategories_find_permalink2 = (_productMainCategories_find2 = productMainCategories.find((category)=>category.id === section.category)) === null || _productMainCategories_find2 === void 0 ? void 0 : _productMainCategories_find2.permalink) !== null && _productMainCategories_find_permalink2 !== void 0 ? _productMainCategories_find_permalink2 : "", "/").concat((_currentCategory_permalink2 = currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.permalink) !== null && _currentCategory_permalink2 !== void 0 ? _currentCategory_permalink2 : "", "?productType=").concat(productType),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                            src: "".concat("https://storage.lamptan.co.th", "/").concat(section.mediaDesktop.name),
                            alt: section.mediaDesktop.name,
                            width: 1230,
                            height: 190,
                            quality: 90
                        })
                    })
                }),
                section.mediaMobile && section.mediaMobile.name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                    position: "relative",
                    mb: 6,
                    display: {
                        base: "block",
                        md: "none"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        href: "/product-categories/".concat((_productMainCategories_find_permalink3 = (_productMainCategories_find3 = productMainCategories.find((category)=>category.id === section.category)) === null || _productMainCategories_find3 === void 0 ? void 0 : _productMainCategories_find3.permalink) !== null && _productMainCategories_find_permalink3 !== void 0 ? _productMainCategories_find_permalink3 : "", "/").concat((_currentCategory_permalink3 = currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.permalink) !== null && _currentCategory_permalink3 !== void 0 ? _currentCategory_permalink3 : "", "?productType=").concat(productType),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                            src: (_ref2 = "".concat("https://storage.lamptan.co.th", "/").concat(section.mediaMobile.name)) !== null && _ref2 !== void 0 ? _ref2 : "/image-icon/empty-image.png",
                            alt: section.mediaMobile.name,
                            width: 1230,
                            height: 190,
                            quality: 90
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                    mx: {
                        base: -4,
                        md: 0
                    },
                    pl: {
                        base: 4,
                        md: 0
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_products_ProductListSwiper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        products: productData && productData.docs.length > 0 ? productData.docs : [],
                        breakpoints: {
                            300: {
                                slidesPerView: 2.5,
                                spaceBetween: 10
                            },
                            768: {
                                slidesPerView: 4.5,
                                spaceBetween: 20
                            },
                            992: {
                                slidesPerView: 5,
                                spaceBetween: 30
                            }
                        }
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (HomeProductCategorySection);


/***/ }),

/***/ 77909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35656);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);





function HomeSingleBanner(param) {
    let { banner , desktopWidth , desktopHeight , mobileWidth , mobileHeight , desktopStyle , mobileStyle  } = param;
    // use i18n
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "home"
    ]);
    var _banner_link, _banner_target;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: banner.mediaDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: (_banner_link = banner.link) !== null && _banner_link !== void 0 ? _banner_link : "",
                target: (_banner_target = banner.target) !== null && _banner_target !== void 0 ? _banner_target : "_self",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: banner.mediaDesktop ? "".concat("https://storage.lamptan.co.th", "/").concat(banner.mediaDesktop.name) : "/image-icon/empty-image.png",
                    alt: "",
                    width: desktopWidth,
                    height: desktopHeight,
                    style: desktopStyle ? desktopStyle : {
                        width: "100%",
                        height: "auto"
                    }
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (HomeSingleBanner);


/***/ }),

/***/ 21572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



function ProductBadge(param) {
    let { type ="special-price" , imageName  } = param;
    const badge = {
        "special-price": {
            src: "/badge/special-price.png",
            alt: "sale"
        },
        new: {
            src: "/badge/new-arrival.png",
            alt: "new"
        },
        "best-seller": {
            src: "/badge/bestseller.png",
            alt: "best-seller"
        },
        "1get1": {
            src: "/badge/1get1.png",
            alt: "1get1"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: imageName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: "".concat("https://storage.lamptan.co.th", "/").concat(imageName),
            alt: imageName,
            width: 50,
            height: 50
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: badge[type].src,
            alt: badge[type].alt,
            width: 50,
            height: 50
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductBadge);


/***/ }),

/***/ 10829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var components_utils_UtilPriceFormatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74046);
/* harmony import */ var hooks_useProductItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13043);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_equal_height_clean__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64400);
/* harmony import */ var react_equal_height_clean__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_equal_height_clean__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _ProductBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21572);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);









function ProductItem(param) {
    let { product  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const { locale  } = router;
    const { featuredImage , salePrice , savingPrice , regularPrice  } = (0,hooks_useProductItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        product
    });
    var _product_productBadge_imageName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
        height: "100%",
        _hover: {
            boxShadow: "0 0 6px #fdb869",
            transition: "all 0.2s ease"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: "\n              /products/".concat(product === null || product === void 0 ? void 0 : product.permalink, "\n            "),
            passHref: true,
            legacyBehavior: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Link */ .rU, {
                height: "100%",
                textDecoration: "none !important",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                    height: "100%",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                            position: "relative",
                            children: [
                                product.productBadge ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Center */ .M5, {
                                    position: "absolute",
                                    top: "0",
                                    left: 3,
                                    zIndex: "docked",
                                    px: 1,
                                    minH: "44.1px",
                                    borderBottomRadius: "4px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductBadge__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        imageName: (_product_productBadge_imageName = product.productBadge.imageName) !== null && _product_productBadge_imageName !== void 0 ? _product_productBadge_imageName : ""
                                    })
                                }) : product.isNewArrival ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Center */ .M5, {
                                    position: "absolute",
                                    top: "0",
                                    left: 3,
                                    zIndex: "docked",
                                    px: 1,
                                    minH: "44.1px",
                                    borderBottomRadius: "4px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductBadge__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        type: "new"
                                    })
                                }) : product.isBestSeller ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Center */ .M5, {
                                    position: "absolute",
                                    top: "0",
                                    left: 3,
                                    zIndex: "docked",
                                    px: 1,
                                    minH: "44.1px",
                                    borderBottomRadius: "4px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductBadge__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        type: "best-seller"
                                    })
                                }) : product.isOnSale ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Center */ .M5, {
                                    position: "absolute",
                                    top: "0",
                                    left: 3,
                                    zIndex: "docked",
                                    px: 1,
                                    minH: "44.1px",
                                    borderBottomRadius: "4px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductBadge__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        type: "special-price"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .AspectRatio */ .oM, {
                                    ratio: 1,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: "".concat(featuredImage),
                                        width: 500,
                                        height: 500,
                                        alt: product.name_en
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                            bg: "#EADECE",
                            py: 2,
                            px: 3,
                            flex: 1,
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_equal_height_clean__WEBPACK_IMPORTED_MODULE_5__.EqualHeightElement, {
                                    name: "title",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X6, {
                                        fontWeight: "300",
                                        textTransform: "uppercase",
                                        fontSize: "14px",
                                        as: "h5",
                                        noOfLines: 3,
                                        flex: 1,
                                        children: locale === "th" ? product.name_th : product.name_en
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                                    justifyContent: "flex-end",
                                    borderTop: "1px solid",
                                    borderColor: "gray.400",
                                    mt: 2,
                                    pt: 1,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .HStack */ .Ug, {
                                                justifyContent: "flex-end",
                                                alignItems: "flex-end",
                                                spacing: 1,
                                                children: salePrice > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                                            fontSize: "xs",
                                                            pt: 1,
                                                            as: "s",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_UtilPriceFormatter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                                price: regularPrice,
                                                                format: "0,0"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                                            color: "primary.500",
                                                            fontSize: "2xl",
                                                            lineHeight: 1.05,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_UtilPriceFormatter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                                price: salePrice,
                                                                format: "0,0"
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: regularPrice > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                                        color: "primary.500",
                                                        fontSize: "2xl",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_UtilPriceFormatter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                            price: regularPrice,
                                                            format: "0,0"
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                                        children: "N/A"
                                                    })
                                                })
                                            }),
                                            savingPrice > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .HStack */ .Ug, {
                                                justifyContent: "flex-end",
                                                mt: 1.5,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                                    fontSize: "xs",
                                                    textTransform: "uppercase",
                                                    bg: "#eb4123",
                                                    flex: "0 0 auto",
                                                    px: 2,
                                                    color: "white",
                                                    children: [
                                                        "Save",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_UtilPriceFormatter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                            price: savingPrice,
                                                            format: "0,0"
                                                        })
                                                    ]
                                                })
                                            }) : null
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductItem);


/***/ }),

/***/ 77412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47741);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_equal_height_clean__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64400);
/* harmony import */ var react_equal_height_clean__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_equal_height_clean__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71911);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30719);
/* harmony import */ var _ProductItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10829);








function ProductListSwiper(param) {
    let { products , navigation =true , breakpoints  } = param;
    const [controlledSwiper, setControlledSwiper] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [isReachEnded, setIsReachEnded] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [currentSliderIndex, setCurrentSliderIndex] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
            position: "relative",
            mx: -1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_equal_height_clean__WEBPACK_IMPORTED_MODULE_3__.EqualHeight, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
                        modules: [
                            swiper__WEBPACK_IMPORTED_MODULE_4__/* .Controller */ .Qr,
                            swiper__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_
                        ],
                        onSwiper: setControlledSwiper,
                        onReachEnd: ()=>setIsReachEnded(true),
                        onReachBeginning: ()=>setIsReachEnded(false),
                        onSlideChange: (swiper)=>{
                            setCurrentSliderIndex(swiper.activeIndex);
                        },
                        loop: false,
                        breakpoints: breakpoints,
                        children: products.map((product, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                                style: {
                                    height: "auto"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                    p: 1,
                                    height: "100%",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductItem__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        product: product
                                    })
                                })
                            }, index))
                    })
                }),
                controlledSwiper && navigation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        !controlledSwiper.isBeginning ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .zx, {
                            display: {
                                base: "none",
                                lg: "inline-flex"
                            },
                            position: "absolute",
                            left: -12,
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontSize: "4xl",
                            colorScheme: "primary",
                            variant: "unstyled",
                            bg: "gray.100",
                            width: "32px",
                            minW: "auto",
                            height: "32px",
                            borderRadius: "full",
                            onClick: ()=>controlledSwiper.slidePrev(),
                            _focus: {
                                boxShadow: "none",
                                bg: "#dcdcdc"
                            },
                            _active: {
                                bg: "#dcdcdc"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                src: "/image-icon/arrow-prev.png",
                                width: 16,
                                height: 18,
                                alt: "prev"
                            })
                        }) : null,
                        !controlledSwiper.isEnd ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .zx, {
                            display: {
                                base: "none",
                                lg: "inline-flex"
                            },
                            position: "absolute",
                            right: -12,
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontSize: "4xl",
                            colorScheme: "primary",
                            variant: "unstyled",
                            bg: "gray.100",
                            width: "32px",
                            minW: "auto",
                            height: "32px",
                            borderRadius: "full",
                            onClick: ()=>controlledSwiper.slideNext(),
                            _focus: {
                                boxShadow: "none",
                                bg: "#dcdcdc"
                            },
                            _active: {
                                bg: "#dcdcdc"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                src: "/image-icon/arrow-next.png",
                                width: 16,
                                height: 18,
                                alt: "next"
                            })
                        }) : null
                    ]
                }) : null
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductListSwiper);


/***/ }),

/***/ 23440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70594);

// Set config defaults when creating the instance
const _axiosAdmin = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://api.lamptan.co.th"
});
_axiosAdmin.defaults.headers.common.Authorization = "";
// Add a request interceptor
_axiosAdmin.interceptors.request.use(function(config) {
    if (config.headers) {
        config.headers["x-custom-lang"] = "th";
    }
    console.debug("AxiosRequest Url", config.method + "-" + config.url);
    // console.log('AxiosRequest Headers', config.headers?.common);
    console.debug("AxiosRequest ".concat(config.method, "-").concat(config.url), config.data);
    return config;
}, function(error) {
    return Promise.reject(error);
});
_axiosAdmin.interceptors.response.use(function(response) {
    console.log("AxiosResponse ".concat(response.config.method, "-").concat(response.config.url, " ").concat(new Date().toLocaleTimeString()), response.data);
    return response;
});
/* harmony default export */ __webpack_exports__["Z"] = (_axiosAdmin);


/***/ }),

/***/ 17032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ PageRepository; }
/* harmony export */ });
/* harmony import */ var libs_axios_admin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23440);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17563);


class PageRepository {
    static findMany(query) {
        return new Promise(async (resolve, reject)=>{
            try {
                const queryStringify = query_string__WEBPACK_IMPORTED_MODULE_1__.stringify({
                    limit: query.limit,
                    page: query.page,
                    sort: query.sort,
                    where: query.where,
                    include: query.include
                });
                const { data  } = await libs_axios_admin__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/v1/pages?".concat(queryStringify));
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Get one
   * @param id
   * @returns {IPage}
   */ static findOne(id) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios_admin__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/v1/pages/".concat(id));
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Get one
   * @param id
   * @returns {IPage}
   */ static findOneByPermalink(permalink) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios_admin__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/v1/pages/permalink/".concat(permalink));
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Create one
   * @param body
   * @returns
   */ static create(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios_admin__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/pages", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Update one
   * @param id
   * @param body
   * @returns
   */ static update(id, body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios_admin__WEBPACK_IMPORTED_MODULE_0__/* ["default"].patch */ .Z.patch("/v1/pages/".concat(id), body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Delete one
   * @param id
   * @returns
   */ static delete(id) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios_admin__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .Z["delete"]("/v1/pages/".concat(id));
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Delete many
   * @param ids
   * @returns {ids}
   */ static deleteMany(ids) {
        return new Promise(async (resolve, reject)=>{
            try {
                // convert ids to queryString
                const queryStringify = query_string__WEBPACK_IMPORTED_MODULE_1__.stringify({
                    ids: ids.join(",")
                });
                const { data  } = await libs_axios_admin__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .Z["delete"]("/v1/pages/many?".concat(queryStringify));
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    constructor(){}
}


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 64400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(()=>{var e={318:e=>{e.exports=function(e){return e&&e.__esModule?e:{default:e}},e.exports.default=e.exports,e.exports.__esModule=!0},8:e=>{function t(n){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?(e.exports=t=function(e){return typeof e},e.exports.default=e.exports,e.exports.__esModule=!0):(e.exports=t=function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.default=e.exports,e.exports.__esModule=!0),t(n)}e.exports=t,e.exports.default=e.exports,e.exports.__esModule=!0},149:(e,t,n)=>{"use strict";var r=function(){return r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},r.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.EqualHeightConsumer=t.EqualHeightProvider=t.EqualHeightContext=void 0;var o,u=(o=n(689))&&o.__esModule?o:{default:o},i=n(32),a=r({setTemporarySizes:function(){},setOriginalChildrenCount:function(){},setChildrenCount:function(){},setForceUpdate:function(){}},i.defaults),l=u.default.createContext({sizes:a&&a.sizes,temporarySizes:a&&a.temporarySizes,update:a&&a.update,animationSpeed:a&&a.animationSpeed,forceUpdate:a&&a.forceUpdate,originalChildrenCount:a&&a.originalChildrenCount,childrenCount:a&&a.childrenCount,setTemporarySizes:a&&a.setTemporarySizes,setOriginalChildrenCount:a&&a.setOriginalChildrenCount,setChildrenCount:a&&a.setChildrenCount,setForceUpdate:a&&a.setForceUpdate,updateOnChange:a&&a.updateOnChange});t.EqualHeightContext=l;var d=l.Provider;t.EqualHeightProvider=d;var s=l.Consumer;t.EqualHeightConsumer=s},899:(e,t,n)=>{"use strict";var r=Object.create?function(e,t,n,r){void 0===r&&(r=n),Object.defineProperty(e,r,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,r){void 0===r&&(r=n),e[r]=t[n]},o=Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t},u=function(e,t,n){if(n||2===arguments.length)for(var r,o=0,u=t.length;o<u;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0});var i,a=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)"default"!==n&&Object.prototype.hasOwnProperty.call(e,n)&&r(t,e,n);return o(t,e),t}(n(689)),l=n(149),d=(i=n(136))&&i.__esModule?i:{default:i},s=(0,a.memo)((function(e){var t=e.children,n=void 0===t?"":t,r=e.name,o=e.tag,i=void 0===o?"div":o,s=e.placeholder,f=void 0!==s&&s,c=e.disable,p=void 0!==c&&c,h=(0,a.useContext)(l.EqualHeightContext),m=h.sizes,v=h.update,g=h.setTemporarySizes,y=h.setOriginalChildrenCount,C=h.setChildrenCount,b=h.animationSpeed,O=(0,a.useState)(),S=O[0],x=O[1],E=(0,a.useRef)(null);(0,a.useEffect)((function(){if(!p)return y((function(e){return e+1})),function(){y((function(e){return e-1}))}}),[p,f]),(0,a.useEffect)((function(){p||function(){if(E.current&&!p){var e=E.current.style.getPropertyValue("height");E.current.style.removeProperty("height");var t=E.current.offsetHeight;E.current.style.setProperty("height",e),g((function(e){return u(u([],e,!0),[{name:r,height:t}],!1)})),p||C((function(e){return e+1}))}}()}),[v,p,f]),(0,a.useMemo)((function(){if(!p){var e=m.findIndex((function(e){return e.name===r}));m&&m[e]&&m[e].height&&x(m[e].height)}}),[m]);var P={height:S+"px",transitionDuration:0===b?"":b+"s"};return f||n?a.default.createElement(a.default.Fragment,null,p?n:a.default.createElement(i,{ref:E,className:d.default.wrapper,style:P},!f&&n)):null}));t.default=s},32:(e,t,n)=>{"use strict";var r=n(318)(n(8)),o=Object.create?function(e,t,n,r){void 0===r&&(r=n),Object.defineProperty(e,r,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,r){void 0===r&&(r=n),e[r]=t[n]},u=Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t},i=function(e,t,n){if(n||2===arguments.length)for(var r,o=0,u=t.length;o<u;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.defaults=void 0;var a=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)"default"!==n&&Object.prototype.hasOwnProperty.call(e,n)&&o(t,e,n);return u(t,e),t}(n(689)),l=n(149);t.defaults={sizes:[],temporarySizes:[],update:!1,forceUpdate:!1,originalChildrenCount:0,childrenCount:0,animationSpeed:.25,timeout:200,updateOnChange:void 0};var d=(0,a.memo)((function(e){var n=e.children,o=e.timeout,u=void 0===o?t.defaults.timeout:o,d=e.animationSpeed,s=void 0===d?t.defaults.animationSpeed:d,f=e.updateOnChange,c=void 0===f?t.defaults.updateOnChange:f,p=(0,a.useState)(t.defaults.sizes),h=p[0],m=p[1],v=(0,a.useState)(t.defaults.temporarySizes),g=v[0],y=v[1],C=(0,a.useState)(t.defaults.update),b=C[0],O=C[1],S=(0,a.useState)(t.defaults.forceUpdate),x=S[0],E=S[1],P=(0,a.useState)(t.defaults.originalChildrenCount),_=P[0],j=P[1],w=(0,a.useState)(t.defaults.childrenCount),q=w[0],H=w[1],M=(0,a.useCallback)((function(){return O((function(e){return!e}))}),[]);return(0,a.useEffect)((function(){var e,t;if("object"===("undefined"==typeof window?"undefined":(0,r.default)(window))&&"object"===(0,r.default)(window.document))return window.addEventListener("resize",u?function(){clearTimeout(e),e=window.setTimeout(M,u)}:M),window.addEventListener("orientationchange",u?function(){clearTimeout(t),t=window.setTimeout(M,u)}:M),function(){window.removeEventListener("resize",M),window.removeEventListener("orientationchange",M)}}),[]),(0,a.useMemo)((function(){M()}),[x,_,c]),(0,a.useMemo)((function(){if(_<=q){var e=[];g.map((function(t){var n=t.name,r=t.height,o=e.findIndex((function(e){return e.name===n}));o>-1?e[o].height<r&&(e[o].height=r):e=i(i([],e,!0),[{name:n,height:r}],!1)})),m(e),y([]),H(0)}}),[q]),a.default.createElement(l.EqualHeightProvider,{value:{sizes:h,temporarySizes:g,update:b,animationSpeed:s,forceUpdate:x,originalChildrenCount:_,childrenCount:q,setTemporarySizes:y,setOriginalChildrenCount:j,setChildrenCount:H,setForceUpdate:E,updateOnChange:c}},n)}));t.default=d},136:(e,t,n)=>{"use strict";n.r(t),n.d(t,{default:()=>r});const r={wrapper:"equal-height-JlocK"}},689:e=>{"use strict";e.exports=__webpack_require__(67294)}},t={};function n(r){var o=t[r];if(void 0!==o)return o.exports;var u=t[r]={exports:{}};return e[r](u,u.exports,n),u.exports}n.d=(e,t)=>{for(var r in t)n.o(t,r)&&!n.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},n.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),n.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var r={};(()=>{"use strict";var e=r,t=function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(e,"__esModule",{value:!0}),e.EqualHeightConsumer=e.EqualHeightProvider=e.EqualHeightContext=e.EqualHeightElement=e.EqualHeight=void 0;var o=n(32);Object.defineProperty(e,"EqualHeight",{enumerable:!0,get:function(){return t(o).default}});var u=n(899);Object.defineProperty(e,"EqualHeightElement",{enumerable:!0,get:function(){return t(u).default}});var i=n(149);Object.defineProperty(e,"EqualHeightContext",{enumerable:!0,get:function(){return i.EqualHeightContext}}),Object.defineProperty(e,"EqualHeightProvider",{enumerable:!0,get:function(){return i.EqualHeightProvider}}),Object.defineProperty(e,"EqualHeightConsumer",{enumerable:!0,get:function(){return i.EqualHeightConsumer}})})(),module.exports=r})();

/***/ })

}]);